export default {
  translation: {
    common: {
      accept: 'Accepter',
      alreadyUser: 'Déjà utilisateur ?',
      and: 'et',
      backToLogin: 'Retour à la page de connexion',
      continueWith: 'Continuer avec {{provider}}',
      coreNotFound: 'Échec de la récupération des paramètres de base',
      createAccount: 'Créer un compte',
      createYourAccount: 'Créez votre compte',
      emailOrUsername: "Email ou nom d'utilisateur",
      invalidUsernameOrPasswords: "Nom d'utilisateur ou mot de passe invalide",
      localRegistrationDisabled: "L'enregistrement local de l'utilisateur est désactivé par l'administrateur",
      login: 'Se connecter',
      logInToBoards: 'Se connecter',
      newToBoards: 'Vous débutez avec les cartes 4ga Boards?',
      noInternetConnection: 'Aucune connection internet',
      pageNotFound_title: 'Page non trouvée',
      password: 'Mot de passe',
      policyNotAccepted: "Veuillez accepter les conditions d'utilisation et la politique de confidentialité",
      privacyPolicy: 'Politique de confidentialité',
      register: 'Registre',
      registerWithGoogle: 'Inscrivez-vous sur Google',
      registrationDisabled: "Toutes les inscriptions d'utilisateurs sont désactivées par l'administrateur",
      serverConnectionFailed: 'Connection au serveur échouée',
      ssoRegistrationDisabled: "L'enregistrement SSO de l'utilisateur est désactivé par l'administrateur",
      termsOfService: "Conditions d'utilisation",
      togglePasswordVisibility: 'Activer/désactiver la visibilité du mot de passe',
      unknownError: 'Erreur inconnue, réessayez plus tard',
    },

    action: {
      logIn: 'Se connecter',
    },
  },
};
